
export default {
  setStorage,
  getStorage,
  removeStorage
}
var ls = window.localStorage
var ss = window.sessionStorage
function setStorage (key, value, flag) {
  if (arguments.length > 1) {
    let v = value
    if (typeof v === 'object') {
      v = JSON.stringify(v)
      v = 'obj-' + v
    } else {
      v = 'str-' + v
    }
    if (ls && ss) {
      if (flag) {
        ls.setItem(key, v)
      } else {
        ss.setItem(key, v)
      }
    }
  }
}

function getStorage (key, flag) {
  // if (ls) {
    let v = ''
    if (flag) {
      v = ls.getItem(key)
    } else {
      v = ss.getItem(key)
    }
    if (!v) {
      return
    }
    if (v.indexOf('obj-') > -1) {
      v = v.slice(4)
      return JSON.parse(v)
    } else if (v.indexOf('str-') > -1) {
      return v.slice(4)
    } else {
      return v
    }
  // }
}

function removeStorage (key, flag) {
  if (flag) {
    window.localStorage.removeItem(key)
  } else {
    window.sessionStorage.removeItem(key)
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/storage.js